import { Empty, Input } from 'antd';
import filter from 'lodash/filter';
import map from 'lodash/map';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import request from 'utils/request';
import { LAGERBOX, TENANTS } from '../../../api';
import Table from './TableStyle';

function List({
  list,
 
}) {
  const { t } = useTranslation();
  const [dataCol, setdataCol] = useState([]);
  const [visible, setVisible] = useState(false);
  const [user, setUser] = useState(null);

  const patchItem = async (values, id) => {
    const responce = await request(`v1${LAGERBOX}${TENANTS}/${id}`, {
      method: 'patch',
      data: {
        ...values,
        token: window.location.hash.split('/')[2],
      },
    }).catch(e => {
      console.log(e);
    }).then(() => {
      setVisible(false);
    });
    console.log(responce);
  };
 

  const columns = [
  
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => {
        return (
          <div className="item-row">
            <span className="item-row">{record.id}</span>
          </div>
        );
      },
      // sorter: (a, b) => Number(a.id) - Number(b.id),
      width: '5%',
    },
    
    {
      title: 'name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        return <div className="item-row">{record.name}</div>;
      },
      // sorter: (a, b) => Number(a.user_name) - Number(b.user_name),
      width: '20%',
    },
    {
      title: 'unit number',
      dataIndex: 'unitnumber',
      key: 'unitnumber',
      width: '20%',
      render: (text, record) => {
        return <div className="item-row">{record.unitnumber}</div> ;
      },
      // sorter: (a, b) => Number(a.unitnumber) - Number(b.unitnumber),
    },{
      title: 'username',
      dataIndex: 'user_name',
      key: 'user_name',
      render: (text, record) => {
        return record.user_name && record.user_name.length > 0 ? (
          <div className="item-row">{record.user_name}</div>
        ) : (
           <div className="item-row"><Input placeholder="Input username" onPressEnter={(e) => {
              console.log(e.target.value)
              patchItem({username: e.target.value}, record.id);
          }}  />
        </div>);
      },
      // sorter: (a, b) => Number(a.user_name) - Number(b.user_name),
      width: '10%',
    },
  ];

  

  useMemo(() => {
    const dataForTable = map(list, (item, index) => {
      return {
        key: index,
        id: item.id,
        username: item.user_name,
        name: item.name,
        unitnumber: item.unitnumber,
      };
    });
    setdataCol(dataForTable);
    if (user) {
      const newData = filter(list, (item) => {
        return item.id === user.id;
      });
      setUser(newData[0]);
    }
  }, [list]);

  return (
    <>
      {dataCol.length !== 0 ? (
        <Table
          className="w-full"
          pagination={false}
          columns={columns}
          showSorterTooltip={false}
          dataSource={dataCol}
        />
      ) : (
        <Empty className="mt-20" />
      )}
    </>
  );
}

List.propTypes = {};

export default List;
